import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const categoryRBAC = {
  pageID: '6a4fc82d4a65995a3c682c83f4825fd9',
  elementID: {
    ViewCategory: 'dd5820f2dcb3cbcd1f96df7af5ef0c37',
    CreateCategory: '7611086f6cd88737e5d9a4d7ca3281c5',
    EditCategory: '100d67567cd9937807cdd1d4ef6a3089',
    DeleteCategory: '31c1914cdfe8042263d6c717532bbfd0',
    ExportCategory: '3b2cc660439526ca17d86f62bcba7dd7',
    BulkUploadCategory: '9ac472635b09d074693658768c35b2e2',
  },
} as const

export const useRBACCategoryPage = createUseRBAC(categoryRBAC.elementID)

export type UseRBACCategoryPageType = ReturnType<typeof useRBACCategoryPage>
